import type { webComponents } from '@streamersonglist/songlist-api-sdk';
import { useOutletContext } from 'react-router';
import type { AdminPermissions } from '../../context';

type StreamerDetails = webComponents['schemas']['StreamerDetails'];

export type StreamerContext = {
  streamer: StreamerDetails;
  isOwner: boolean;
  isOwnerOrAdmin: boolean;
  isLoggedIn: boolean;
  routePrefix: string;
  platform: string;
  currentUsername: string;
  adminPermissions: AdminPermissions | null;
  // The logged-in viewer's active permit for this streamer, when one exists.
  activePermit: { id: string; expiresAt?: string | null } | null;
  tokensEnabled: boolean;
  // null when anonymous, feature disabled, or the balance lookup failed — a
  // failed lookup must not masquerade as a zero balance.
  tokenBalance: number | null;
  /**
   * Lets a page hide the streamer nav for as long as it is open. The layout
   * owns the sidebar, so a page that wants the width has to ask for it — and
   * gets it back automatically when it unmounts.
   */
  navHidden: boolean;
  setNavHidden: (hidden: boolean) => void;
};

export function useStreamerContext() {
  return useOutletContext<StreamerContext>();
}

// For components that also render outside the streamer layout (or in isolated
// tests) and only enhance their UI when the context is present.
export function useOptionalStreamerContext(): StreamerContext | null {
  return useOutletContext<StreamerContext | null>() ?? null;
}
